<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :showAdd="false"
    :router="{
      name: 'GEOFENCE_LIST',
    }"
  >
    <Notice class="col-span-full mb-6 border-0">
      {{ $t('AreaInstructions') }}
    </Notice>

    <div class="col-span-full mb-4" id="mapid" ref="mapElement"></div>

    <customDialog
      v-if="showMap"
      :title="$t('SETTING')"
      childClass="info_msg add_geo"
      :show="showMap"
      :showCancel="true"
      customWidth="60%"
      :showClose="true"
      @show="showMap = $event"
      @close="clickOutsideOfDialog()"
      @confirmButn="submitGeofence('ruleForm')"
    >
      <el-form
        status-icon
        :model="ruleForm"
        label-position="top"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm grid grid-cols-1 gap-4 status-icon"
      >
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 pt-2 relative">
          <el-form-item
            :label="$t('AREA_TITLE')"
            prop="title"
            :rules="{
              required: true,
              message: $t('REQUIRED_FIELD', {
                type: $t('AREA_TITLE'),
              }),
              trigger: 'blur',
            }"
          >
            <el-input
              :disabled="ruleForm.disabled"
              type="text"
              v-model="ruleForm.title"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="flex items-center justify-center"
            prop="is_forbidden"
          >
            <el-switch
              :disabled="ruleForm.disabled"
              v-model="ruleForm.is_forbidden"
              active-color="#ff4949"
              inactive-color="#13ce66"
              :active-text="$t('FORBIDDEN')"
              :inactive-text="$t('FREE')"
            >
            </el-switch>
          </el-form-item>

          <div class="col-span-full grid grid-cols-1 lg:grid-cols-2 gap-4">
            <el-form-item
              :label="$t('AREA_COLOR')"
              prop="color.id"
              v-loading="colorLoading"
              element-loading-spinner="el-icon-loading"
              :rules="{
                required: true,
                message: $t('REQUIRED_FIELD', {
                  type: $t('AREA_COLOR'),
                }),
                trigger: 'blur',
              }"
            >
              <el-select
                :disabled="ruleForm.disabled"
                :placeholder="$t('SELECT_PLACEHOLDER')"
                v-model="ruleForm.color.id"
                clearable
                filterable
              >
                <template slot="prefix">
                  <span
                    class="prefix w-2 h-2 rounded-full border border-gray-200"
                    :style="`background-color: ${prefixGenerateColor}`"
                  ></span>
                </template>
                <el-option
                  v-for="item in colorList"
                  :key="item.id"
                  :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
                  :value="item.id"
                >
                  <div class="flex items-center">
                    <span
                      :style="`background-color:${item.code}`"
                      class="mx-2 w-2 h-2 rounded-full border border-gray-200"
                    ></span>
                    <span>
                      {{ $i18n.locale == 'fa' ? item.fa_title : item.en_title }}
                    </span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>

            <VehicleSelect
              :loading="vehicleLoading"
              prop="company_vehicle.id"
              :model="ruleForm.company_vehicle.id"
              @update="ruleForm.company_vehicle.id = $event"
              :multiple="true"
              :collapseTags="true"
              :disabled="ruleForm.disabled"
            />

            <el-form-item
              :label="$t('STATUS')"
              prop="is_active"
              :rules="{
                required: true,
                message: $t('REQUIRED_FIELD', {
                  type: $t('STATUS'),
                }),
                trigger: 'blur',
              }"
            >
              <el-select
                :disabled="ruleForm.disabled"
                filterable
                v-model="ruleForm.is_active"
                :placeholder="$t('SELECT_PLACEHOLDER')"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              :label="$t('MAX_SPEED')"
              prop="max_speed"
              :rules="{
                required: true,
                message: $t('REQUIRED_FIELD', {
                  type: $t('MAX_SPEED'),
                }),
                trigger: 'blur',
              }"
            >
              <el-input-number
                :disabled="ruleForm.disabled"
                v-model="ruleForm.max_speed"
                :step="10"
              ></el-input-number>
            </el-form-item>

            <el-form-item
              :label="$t('START_TIME')"
              prop="start_time"
              :rules="{
                required: false,
                message: $t('REQUIRED_FIELD', {
                  type: $t('START_TIME'),
                }),
                trigger: 'blur',
              }"
            >
              <el-time-picker
                disabled
                format="HH:mm"
                value-format="HH:mm"
                v-model="ruleForm.start_time"
              >
              </el-time-picker>
            </el-form-item>
            <el-form-item
              :label="$t('END_TIME')"
              prop="end_time"
              :rules="{
                required: false,
                message: $t('REQUIRED_FIELD', {
                  type: $t('END_TIME'),
                }),
                trigger: 'blur',
              }"
            >
              <el-time-picker
                disabled
                format="HH:mm"
                value-format="HH:mm"
                v-model="ruleForm.end_time"
              >
              </el-time-picker>
            </el-form-item>
          </div>
          <el-form-item
            class="col-span-full"
            :label="$t('description')"
            prop="description"
          >
            <el-input
              :disabled="ruleForm.disabled"
              type="textarea"
              v-model="ruleForm.description"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </customDialog>

    <div class="flex justify-end col-span-full mt-4 mb-0">
      <el-button type="success" @click.prevent="mySubmit">{{
        $t('SUBMIT')
      }}</el-button>
    </div>
  </Content>
</template>
<script>
import { colorList } from '@/api/global'
import { fenceShape, addfence } from '@/api/fence'
import config from '@/configs/configs.js'
import { resetForm } from '@/mixins/resetForm'
import customDialog from '@/components/elements/dialog'
import { searchAddress } from '@/mixins/searchAddress'
import Notice from '@/components/elements/notice'
import VehicleSelect from '@/components/elements/vehiclesSelect.vue'
import { convertToUTC } from '@/mixins/convertToUTC'

export default {
  components: {
    customDialog,

    Notice,
    VehicleSelect,
  },

  computed: {
    prefixGenerateColor() {
      return this.colorList.find((i) => i.id == this.ruleForm.color.id) !=
        undefined
        ? this.colorList.find((i) => i.id == this.ruleForm.color.id).code
        : ''
    },
  },
  mixins: [searchAddress, resetForm, convertToUTC],
  data() {
    return {
      default: [35.71343059526645, 51.407055307645365],
      map: null,
      showMap: false,
      loading: true,
      fenceShapes: null,
      vehciles: [],
      vehicleLoading: true,
      speed_rules: [],
      speedDialog: false,
      timeDialog: false,
      time_rules: [],
      colorList: [],
      colorLoading: true,
      currentLayer: null,
      activeName: 'BASIC_INFO',
      statusList: [
        {
          value: true,
          label: this.$i18n.t('ACTIVE'),
        },
        {
          value: false,
          label: this.$i18n.t('INACTIVE'),
        },
      ],
      ruleForm: {
        company_vehicle: {
          id: '',
        },
        color: {
          id: 1,
        },
        is_active: true,
        is_forbidden: false,
        title: '',
        description: '',
        disabled: false,
        max_speed: 80,
        start_time: new Date(2021, 9, 10, 0, 0),
        end_time: new Date(2021, 9, 10, 23, 59, 59),
        description: '',
        modalType: '',
        isFenceCreated: false,
        // color: 0,
      },

      fence: [],
    }
  },
  methods: {
    mySubmit() {
      if (this.fence.length == 0) {
        this.$notify.error({
          title: this.$i18n.t('REQUIRED_FIELD', {
            type: this.$i18n.t('GEOFENCE'),
          }),
          duration: 5000,
          customClass: 'error_msg',
        })
        return false
      }
      var result = this.fence.map((data) => ({
        max_speed: data.max_speed,
        title: data.title,
        features: data.features,
        is_active: data.is_active,
        is_forbidden: data.is_forbidden,
        description: data.description,
        company_vehicles:
          data.company_vehicle == '' ? [] : data.company_vehicle,
        color: data.color,
        shape: data.shape,
      }))
      const actionPayload = result[0]

      addfence.api(actionPayload).then((res) => {
        if (res) {
          this.$notify.success({
            title:
              this.$t(this.$route.name) + ' ' + this.$t('SUCCESSFULLY_DONE'),
            duration: 5000,
            customClass: 'succ_msg',
          })
          this.map.eachLayer(function (layer) {
            if (layer._path != null) {
              layer.remove()
            }
          })
          this.resetPopupForm('ruleForm')
          this.$router.push({
            name: 'GEOFENCE_LIST',
          })
        }
      })
    },

    clickOutsideOfDialog() {
      if (this.currentLayer) {
        this.resetPopupForm('ruleForm')

        if (this.modalType === 'add') {
          this.map.removeLayer(this.currentLayer)
          this.removeOldLayer(this.currentLayer)
          this.isFenceCreated = false
        }
        this.currentLayer = null
      }
      this.showMap = false
    },

    submitGeofence(formName = 'ruleForm') {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fenceGenreate(this.ruleForm)
          this.changeLayerColor(
            this.currentLayer,
            this.prefixGenerateColor,
            !this.ruleForm.is_active ? '.5' : '.8',
            this.ruleForm.title
          )

          this.showMap = false
          this.resetPopupForm(formName)
          this.currentLayer = null
        }
      })
    },
    resetPopupForm(formName) {
      this.resetForm(formName)
      this.ruleForm.color.id = 1
      this.ruleForm.company_vehicle.id = ''
    },
    fenceGenreate(data, type = 'add') {
      let currenctFence = this.fence.find(
        (data) => data.id == this.currentLayer.id
      )

      if (type == 'add') {
        currenctFence.title = data.title
        currenctFence.description = data.description
        currenctFence.color = data.color.id
        currenctFence.company_vehicle = data.company_vehicle.id
        currenctFence.is_active = data.is_active
        currenctFence.is_forbidden = data.is_forbidden
        currenctFence.max_speed = data.max_speed
        currenctFence.start_time = data.start_time
        currenctFence.end_time = data.end_time
      } else if (type == 'edit') {
        data.title = currenctFence.title
        data.description = currenctFence.description
        data.color.id = currenctFence.color
        data.company_vehicle.id = currenctFence.company_vehicle
        data.is_active = currenctFence.is_active
        data.is_forbidden = currenctFence.is_forbidden
        data.max_speed = currenctFence.max_speed
        data.start_time = currenctFence.start_time
        data.end_time = currenctFence.end_time
      }
    },

    addNonGroupLayers(sourceLayer, targetGroup) {
      if (sourceLayer instanceof L.LayerGroup) {
        sourceLayer.eachLayer(function (layer) {
          this.addNonGroupLayers(layer, targetGroup)
        })
      } else {
        targetGroup.addLayer(sourceLayer)
      }
    },

    loadMap() {
      var map = L.map(this.$refs['mapElement'], {
        tap: false,
      }).setView(this.default, 10)
      L.tileLayer(config.tile, {
        attribution: '@ Carpo',
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        accessToken: config.leaflet,
      }).addTo(map)
      this.map = map
      var fg = L.featureGroup()
      const provider = new window.GeoSearch.OpenStreetMapProvider()
      const search = new GeoSearch.GeoSearchControl({
        provider: provider,
        style: 'bar',
        updateMap: true,
        autoClose: true,
      })
      map.addControl(search)
      map.pm.setLang('fa')

      var randomNum = 0

      map.on('pm:create', (e) => {
        if (this.isFenceCreated) {
          // If a fence has already been created, prevent adding another
          this.$notify.warning({
            title: 'اخطار',
            message:
              'در هر ثبت ناحیه جغرافیایی، مجاز به اضافه کردن یک ناحیه هستید',
            duration: 5000,
            customClass: 'warning_msg',
          })
          map.removeLayer(e.layer) // Remove the newly created layer
          return
        }

        let myLayer = e.layer
        randomNum++

        let shape = e.shape.toLowerCase()

        fg.addLayer(myLayer)
        this.showMap = true
        let geoJson = e.layer.toGeoJSON()
        this.fence.push({
          myLayer: myLayer,
          id: randomNum,
          features:
            shape != 'circle'
              ? [geoJson.geometry.coordinates[0]]
              : {
                  radius: e.layer.getRadius(),
                  coordinates: geoJson.geometry.coordinates,
                },
          shape: this.shapeDic(shape),
        })
        myLayer.id = randomNum
        this.currentLayer = myLayer
        this.currentLayer.id = randomNum
        this.modalType = 'add'

        myLayer.on('pm:edit', (e) => {
          let newLayer = e.layer
          this.currentLayer = newLayer
          this.currentLayer.id = newLayer.id

          let currenctFence = this.fence.find((data) => data.id == newLayer.id)

          currenctFence.features =
            shape != 'circle'
              ? [newLayer.toGeoJSON().geometry.coordinates[0]]
              : {
                  radius: e.layer.getRadius(),
                  coordinates: newLayer.toGeoJSON().geometry.coordinates,
                }
        })

        myLayer.on('pm:remove', (e) => {
          fg.removeLayer(e.layer)
          this.removeOldLayer(myLayer)
          this.isFenceCreated = false // Reset the flag when the fence is removed
        })

        myLayer.on('dblclick', (e) => {
          this.showMap = true
          this.currentLayer = myLayer
          this.currentLayer.id = myLayer.id
          this.fenceGenreate(this.ruleForm, 'edit')
          this.modalType = 'edit'
        })

        this.isFenceCreated = true // Set the flag to indicate that a fence has been created
      })

      map.doubleClickZoom.disable()

      map.pm.addControls({
        position: 'topleft',
        drawPolyline: false,
        drawCircleMarker: false,
        drawMarker: false,
        drawCircle: true,
        drawRectangle: false,
        drawText: false,
        cutPolygon: false,
        rotateMode: false,
        dragMode: true,
        editMode: true,
      })
    },

    changeLayerColor(layer, color, opacity = 0.8, title = '') {
      layer.getElement().setAttribute('fill', color)
      layer.getElement().setAttribute('stroke', color)
      layer.getElement().setAttribute('opacity', opacity)
      layer.getElement().setAttribute('fill-opacity', opacity)
      // let newTitle = document.createElement("text");
      // newTitle.innerHTML = title;
      // layer.getElement().parentElement.appendChild(newTitle);
    },
    shapeDic(myShape) {
      return this.fenceShapes.find(
        (shape) => shape.en_title.toLowerCase() == myShape.toLowerCase()
      ).id
    },
    removeOldLayer(layer) {
      this.fence = this.fence.filter((data) => data.id !== layer.id)
    },
  },
  mounted() {
    this.searchAddress().then((res) => {
      if (res) {
        this.loadMap()
      }
    })
    colorList.api().then((res) => {
      if (res) {
        this.colorList = res
        this.colorLoading = false
      }
    })
    fenceShape.api().then((res) => {
      if (res) {
        this.fenceShapes = res
        this.loading = false
      }
    })
  },
}
</script>
